import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetUser } from 'redux/actions/auth';
import LoginRequired from './LoginRequired';

class LoginRequiredSubscriptions extends React.Component {
  state = {
    isRender: false
  }

  componentWillMount() {
    this.props.resetUser(() => this.setState({ isRender: true }));
  }

  render() {
    const { isRender } = this.state;
    if (!isRender) {
      return null;
    }
    return (
      <LoginRequired
        {...this.props}
      />
    );
  }
}

LoginRequiredSubscriptions.propTypes = {
  resetUser: PropTypes.func.isRequired,
};

export default connect(null, { resetUser })(LoginRequiredSubscriptions);



// WEBPACK FOOTER //
// ./src/components/RouteWrappers/LoginRequiredSubscriptions.jsx